import React from 'react'

type IconRoundProps = {
  icon: any;
  text?: string;
}

const IconRound: React.FC<IconRoundProps> = (props) => {
  const { icon, text } = props;

  const IconComponent = icon;

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="flex items-center justify-center w-15 h-15 rounded-full bg-primary/10">
        <IconComponent className="size-6 primary-color" />
      </div>
      {text && <span className="text-sm font-semibold">{text}</span>}
    </div>
  )
}

export default IconRound;